import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo, Back, Sine } from 'gsap';
import { ScrollTrigger, DrawSVGPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {

        const brow = el.querySelector('.callout__brow > span');
        const heading = el.querySelector('.callout__heading > h2');
        const subtext = el.querySelector('.callout__subtext > p');
        const link = el.querySelector('.callout__link > a');
        const verticalRule = el.querySelector('.callout--vertical-rule');

        gsap.set(verticalRule, { transformOrigin: 'center top' });

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                end: 'top 40%',
                scrub: 1,
                markers: false
            },
            paused: true
        })

        gsap.from(verticalRule, {
            duration: 1,
            opacity: 0,
            scaleY: 0,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top 40%',
                scrub: 1,
                markers: false
            }
        });

        timeline.from(brow, {
            duration: 1,
            opacity: 0,
            yPercent: 100,
            ease: 'none'
        })

        timeline.from(heading, {
            duration: 1,
            opacity: 0,
            yPercent: 100,
            ease: 'none'
        })

        timeline.from(subtext, {
            duration: 1,
            opacity: 0,
            yPercent: 50,
            ease: 'none'
        })

        timeline.from(link, {
            duration: 1,
            opacity: 0,
            ease: 'none'
        })




    });
}
